<template>
  <v-flex xs12>
    <div v-if="isAdmin" class="text-xs-left">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <h2>{{natOrgObj.name}}</h2>
            <p>{{natOrgObj.email}} <br/>
              {{natOrgObj.url}}
            </p>
          </v-card-text>
          <v-card-text style="height: 20px; position: relative">
            <NatOrgForm v-bind:isNew="false" v-bind:id="id" v-bind:obj="natOrgObj"/>
          </v-card-text>
        </v-card>
      </v-flex>

      <NatOrgLicenses v-bind:id="id" v-bind:obj="natOrgObj"/>
      <NatOrgCompetitions v-bind:id="id" v-bind:obj="natOrgObj"/>
    </div>

    <v-card v-else>Admins Only</v-card>
  </v-flex>
</template>
<script>
import NatOrgForm from "@/components/NatOrgForm";
import NatOrgLicenses from "@/components/NatOrgLicenses";
import NatOrgCompetitions from "@/components/NatOrgCompetitions";
import { mapGetters } from "vuex";
export default {
  name: "NatOrgDetail",
  components: {
    NatOrgForm,
    NatOrgLicenses,
    NatOrgCompetitions
  },
  created() {
   this.$store.dispatch("initNatOrg", this.id);

  },
  computed: {
    ...mapGetters(["isAdmin", "natOrgs"]),
    id() {
      return this.$route.params.id;
    },
    natOrgObj() {
      return this.natOrgs[this.id];
    }
  }
};
</script>
